import { Snackbar } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Collection } from "@type-r/models";
import { useLinked } from "@type-r/react";
import { Columns, TilesList } from "lqx-react";
import React from "react";
import { ImportTemplateCard } from "../api/importTemplateCard";
import { DetailsPaneColumn, TilesListColumn } from "../components/item-card-styles";
import { PopupActionDialog } from "../components/popups/popup-action-dialog";
import { ImportTemplatesCardRenderer } from "./import-templates-card-renderer";
import { ImportTemplatesDetailsPane } from "./import-templates-details-pane";

export const ImportTemplatesList = ({ importTemplateCards }: { importTemplateCards: Collection<ImportTemplateCard> }) => {
  const $activeCard = useLinked<ImportTemplateCard>(null);
  const $selectedTab = useLinked('details');
  const defaultContext = { onApply: null, onCancel: null, actionType: '', actionText: '', isPopupOpen: false };
  const $popupContext = useLinked<{
    onApply: any,
    onCancel: any,
    actionType: String,
    actionText: String,
    isPopupOpen: boolean
  }>(defaultContext);
  const $showAlertMessage = useLinked<boolean>(false);
  const $errorMessage = useLinked("");

  const handleCloseShowErrors = (_, reason) => {
    if (reason === 'clickaway') return;
    $showAlertMessage.set(false);
  };

  const onCancel = () => $popupContext.set(defaultContext);

  const onApply = async (id) => {
    $activeCard.set(null);
    $errorMessage.set("");

    $popupContext.set(defaultContext);
    await importTemplateCards.find(i => i.id === id)
      .delete()
      .then(id => importTemplateCards.remove(id))
      .catch(e => $errorMessage.set(e.message));
    $showAlertMessage.set(true);
  }

  const onDelete = (id) => {
    if (id) {
      $popupContext.set({
        onApply: () => onApply(id),
        onCancel: () => onCancel(),
        actionType: 'Delete',
        actionText: 'Are you sure you want to Delete this Import Template?',
        isPopupOpen: true
      });
    }
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={$showAlertMessage.value}
        autoHideDuration={6000}
        onClose={handleCloseShowErrors}>
        {$errorMessage.value.length > 0 ?
          <Alert severity="error">
            <AlertTitle>Error during deletion of Import Template</AlertTitle>
            {$errorMessage.value}
          </Alert> :
          <Alert severity="success">
            <AlertTitle>Successfuly deleted</AlertTitle>
          </Alert>
        }
      </Snackbar>
      <Columns style={{ height: 'calc(100% - 80px)' }}>
        <TilesListColumn>
          <TilesList
            items={importTemplateCards.models}
            itemSize={100}
            renderer={ImportTemplatesCardRenderer($activeCard, $selectedTab, onDelete)}
          />
        </TilesListColumn>
        {$activeCard.value &&
          <DetailsPaneColumn>
            <ImportTemplatesDetailsPane $activeCard={$activeCard} $selectedTab={$selectedTab} onDelete={onDelete} />
          </DetailsPaneColumn>}
      </Columns>
      <PopupActionDialog $context={$popupContext} />
    </>
  );
};
